// Fonction pour envoyer la requête POST

const sendPostRequest = async (data) => {
  let cheminURLAPI;
  switch (document.domain) {
    case "localhost":
      cheminURLAPI = "https://carboparc.itmsol.fr/api_carbo";
      break;
    case "carboparc.itmsol.fr":
      cheminURLAPI = "https://carboparc.itmsol.fr/api_carbo";
      break;
    case "carboparc-dev.itmsol.fr":
      cheminURLAPI = "https://carboparc.itmsol.fr/api_carbo";
      break;
    default:
      cheminURLAPI = "./index.php";
  }

  try {
    const response = await fetch(cheminURLAPI, {
      method: "POST", // Méthode HTTP
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(data), // convertit l'objet data en chaîne JSON
    });
    let res;
    if (!response.ok) {
      throw new Error(`Erreur: ${response.status}`);
    }
    if (response.headers.get("Content-Type").includes("application/json")) {
      res = await response.json();
    } else {
      res = await response.text();
    }
    return res;
  } catch (error) {
    console.error("Erreur lors de l'envoi de la requête:", error);
  }
};

export default sendPostRequest;
